import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

export const salesModule: ForqModuleManifest = {
  id: 'sales',
  name: 'Sales',
  description: 'Verkaufschancen, Angebote, Verkaufsaufträge und Übergaben',
  version: '0.1.0',
  route: '/verkauf',
  category: 'commercial',
  status: 'development',
  requiredPermissions: ['sales.view'],
  features: [
    'sales.overview',
    'sales.pipeline',
    'sales.offers',
    'sales.orders',
    'sales.handoffs',
  ],
  navigation: [
    { id: 'sales.primary', label: 'Sales', route: '/verkauf', placement: 'primary', order: 50, icon: 'verkauf' },
    { id: 'sales.launcher', label: 'Sales', route: '/verkauf', placement: 'launcher', order: 50, icon: 'verkauf' },
  ],
};

export const salesFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'sales.overview', moduleId: 'sales', name: 'Übersicht',
    description: 'Pipeline, Nachfassaktionen, Abschlüsse und Übergaben', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['sales.view'], uiSlots: [], emits: [], listensTo: ['tenant.changed', 'sales.offer.decided'],
  },
  {
    id: 'sales.pipeline', moduleId: 'sales', name: 'Pipeline',
    description: 'Verkaufschancen, Kontakte und nächste Aktionen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['sales.pipeline.view'], uiSlots: [], emits: ['sales.opportunity.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'sales.offers', moduleId: 'sales', name: 'Angebote',
    description: 'Telefonische und dokumentierte Angebote mit Positionen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['sales.offers.view'], uiSlots: [], emits: ['sales.offer.changed', 'sales.offer.decided'], listensTo: ['tenant.changed'],
  },
  {
    id: 'sales.orders', moduleId: 'sales', name: 'Verkaufsaufträge',
    description: 'Aus gewonnenen Angeboten erzeugte Verkaufsaufträge', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['sales.orders.view'], uiSlots: [], emits: [], listensTo: ['sales.offer.decided'],
  },
  {
    id: 'sales.handoffs', moduleId: 'sales', name: 'Übergaben',
    description: 'Persistente Übergaben an Finance und Logistics', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['sales.handoffs.view'], uiSlots: [], emits: [], listensTo: ['sales.offer.decided'],
  },
];
